












import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
import Order from "@/models/order/Order";
import {Icon} from "@/helpers/icons";
import {formatCurrency} from "@/helpers/functions_asi";
import OrderUpdateDialogRates from "@/components/order/OrderUpdateDialogRates.vue";
import {Permissions} from "@/helpers/constants";

@Component({
	components: {OrderUpdateDialogRates, AsiCardDetailEntry, AsiCardDetail}
})
export default class OrderCardRates extends Vue {

	@Prop({type: Object, required: true})
	public order!: Order;

	private icons = Icon;
	private updateDialogOpen: boolean = false;

	private get isBilling(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightBilling);
	}

	private get isMasterData(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightMasterData);
	}

	@Emit('orderChanged')
	public orderChanged(event: Event): Event {
		this.updateDialogOpen = false;
		return event;
	}

	private formatCurrencyAmount(amount: number | null): string | null {
		return formatCurrency(amount);
	}

}
